import { render } from "./service.vue?vue&type=template&id=6f84ec5b&scoped=true"
const script = {}

import "./service.vue?vue&type=style&index=0&id=6f84ec5b&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f84ec5b"]])

export default __exports__